import React from 'react';
import styled from '@emotion/styled';
import { Blinker } from 'core/models/drive';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft, faArrowAltCircleRight, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { exhaustiveCheck } from 'utility/exhaustiveCheck';

type ButtonProps = {
    selected: boolean;
}

const Button = styled.button<ButtonProps>(props => ({
    fontSize: '18px',
    height: '100%',
    borderRadius: '6px',
    color: props.selected ? '#fff' : 'ButtonText',
    backgroundColor: props.selected ? '#f0ad4e' : '#fff',
    borderColor: props.selected ? '#eea236' : '#ccc',
    ':hover': {
        backgroundColor: props.selected ? '#ec971f' : '#e6e6e6',
        borderColor: props.selected ? '#d58512' : '#adadad',
    },
    ':focus': {
        outline: 'unset',
    },
}));

export type BlinkerButtonProps = {
    className?: string;
    blinker: Blinker;
    selected: boolean;
    onClick?: () => void;
}

export const BlinkerButton = (props: BlinkerButtonProps) => {
    function iconForMode(blinker: Blinker) {
        switch (blinker) {
            case Blinker.Left:
                return faArrowAltCircleLeft;
            case Blinker.Right:
                return faArrowAltCircleRight;
            case Blinker.Hazard:
                return faExclamationTriangle;
            default:
                throw (exhaustiveCheck(blinker));
        }
    }

    return (
        <Button className={props.className} selected={props.selected} onClick={props.onClick}>
            <FontAwesomeIcon icon={iconForMode(props.blinker)} />
        </Button>
    );
};
